import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListViewPanelTabs extends Component {
  static propTypes = {
    setViewPanel: PropTypes.func.isRequired,
    viewPanel: PropTypes.string,
  }
  //
  constructor(props) {
    super(props)
    let viewTabConfig = null
    switch (config.app.title) {
      case 'Fossil Free Funds':
        viewTabConfig = [
          ['results', 'Fossil fuels'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Deforestation Free Funds':
        viewTabConfig = [
          ['results', 'Deforestation'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Weapon Free Funds':
        viewTabConfig = [
          ['results', 'Military weapons'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Gun Free Funds':
        viewTabConfig = [
          ['results', 'Civilian firearms'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Tobacco Free Funds':
        viewTabConfig = [
          ['results', 'Tobacco'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Gender Equality Funds':
        viewTabConfig = [
          ['results', 'Gender equality'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Prison Free Funds':
        viewTabConfig = [
          ['results', 'Prison industrial complex'],
          // ['performance', 'Performance'],
          ['iyv', 'Sustainability']
        ]
        break
      case 'Invest Your Values':
        viewTabConfig = [
          ['results', 'Sustainability'],
          // ['performance', 'Performance'],
        ]
        break
      default:
        break
    }
    this.state = {
      viewTabConfig
    }
  }
  //
  render() {
    return <div styleName='view-panel-tabs'>
      { /* view panel config is [id string, label string]*/
        this.state.viewTabConfig.map((viewPanel, idx) => {
          return (
            <button
              key={'viewpanel-tab-'+idx}
              onClick={() => { this.props.setViewPanel(viewPanel[0]) }}
              styleName={
                this.props.viewPanel===viewPanel[0] ?
                  'view-panel-tab-active' :
                  'view-panel-tab'
              }
              role='button'
              tabIndex='0'
            >
              { viewPanel[1] }
            </button>
          )
        })
      }
    </div>
  }
}